/**
 * Single-line text input with **`qz-input`** styling.
 *
 * @param options - Identity, placeholder, value, disabled, and invalid flag.
 * @returns Native **`input[type=text]`** (caller may wrap with **`createField`**).
 */
export function createTextInput(
  options: Readonly<{
    id: string;
    name?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: string;
    invalid?: boolean;
  }>,
): HTMLInputElement {
  const input = document.createElement("input");
  input.type = "text";
  input.className = "qz-input qz-input--text";
  if (options.name !== undefined) {
    input.name = options.name;
  }
  if (options.placeholder !== undefined) {
    input.placeholder = options.placeholder;
  }
  if (options.disabled === true) {
    input.disabled = true;
  }
  if (options.value !== undefined) {
    input.value = options.value;
  }
  if (options.value !== undefined) {
    input.value = options.value;
  }
  if (options.invalid === true) {
    input.setAttribute("aria-invalid", "true");
  }
  input.id = options.id;
  return input;
}
